import {sendMobileAnalyticsEvent, PDP} from '@optimaxdev/analytics/mobile';

import {WIZARD_EVENT_TYPE} from '../../constants/analytics';
import {PRESCRIPTION_FIELDS} from '../../constants/prescription';
import {ValidationResultType} from 'components/wizard/__utils';
import {WizardStepType} from 'features/wizardMs/reducers/wizardStepV2/wizardStep';

/**
 * Sends analytics events for the prescription errors after validation
 * @param {ValidationResultType} errors - prescription errors
 * @param {string} productType - product type
 */
export const sendPrescriptionErrorAnalytics = (
    errors: ValidationResultType,
    productType: 'sunglasses' | 'eyeglasses',
) => {
    const fields = Object.entries(errors)
        .filter(([, value]) => Boolean(value))
        .reduce((acc: string[], [item]) => {
            if (acc.indexOf(PRESCRIPTION_FIELDS[item]) === -1)
                return [...acc, PRESCRIPTION_FIELDS[item]];
            return acc;
        }, [])
        .join('|');

    if (fields) {
        sendMobileAnalyticsEvent(PDP.LENS_FUNNEL, {
            type: WIZARD_EVENT_TYPE[productType],
            action: 'Step 2: Prescription',
            label: `Fill It Online - Error - Please fill out the missing fields - ${fields}`,
        });
    }
};

const CTA_EVENT_LABELS = {
    fill_it_out_online: 'Fill it out online',
    use_saved: 'Use saved prescription',
    upload: 'Upload image',
};

/**
 * Send analytics event for the "continue" button
 * @param {string} comment - comment
 * @param {string} step - prescription step
 * @param {boolean} isMultiPD - does prescription have multi PD
 * @param {string} productType - type of the product
 */
export const sendContinueButtonAnalytics = ({
    step,
    isMultiPD = false,
    productType,
}: {
    step: WizardStepType['prescriptionStep'];
    isMultiPD?: boolean;
    productType: string;
}) => {
    if (step)
        sendMobileAnalyticsEvent(PDP.LENS_FUNNEL, {
            type: WIZARD_EVENT_TYPE[productType],
            action: 'Step 2: Prescription',
            label: `${CTA_EVENT_LABELS[step]} - Continue`,
        });

    if ((step === 'fill_it_out_online' || step === 'use_saved') && isMultiPD)
        sendMobileAnalyticsEvent(PDP.LENS_FUNNEL, {
            type: WIZARD_EVENT_TYPE[productType],
            action: 'Step 2: Prescription',
            label: '2 PD numbers - Marked',
        });
};

/**
 * Send analytics event for the "send later" button
 * @param {string} step - prescription step
 * @param {string} productType - type of the product
 */
export const sendSendLaterAnalytics = ({
    step,
    productType,
}: {
    step: WizardStepType['prescriptionStep'];
    productType: string;
}) => {
    if (step)
        sendMobileAnalyticsEvent(PDP.LENS_FUNNEL, {
            type: WIZARD_EVENT_TYPE[productType],
            action: 'Step 2: Prescription',
            label: `${CTA_EVENT_LABELS[step]} - Send later`,
        });
};

/**
 * Send analytics event for the save my prescription checkbox
 * @param {string} productType - type of the product
 * @param {string} status - checkbox status
 */
export const sendMyPrescriptionAnalytics = (productType, status: 'Success' | 'Unmarked') => {
    sendMobileAnalyticsEvent(PDP.LENS_FUNNEL, {
        type: WIZARD_EVENT_TYPE[productType],
        action: 'Step 2: Prescription',
        label: `Save my prescription - ${status}`,
    });
};
